import { createSlice } from '@reduxjs/toolkit';

export const patientFeedbackSlice = createSlice({
  name: 'patientFeedback',

  initialState: {
    message: null,
    data: null,
    status: 'checking',
  },
  reducers: {
    chekingPatientFeedback: (state) => {
      state.status = 'checking';
    },
    setPatientFeedback: (state, { payload }) => {
      state.message = payload.message;
      state.data = payload.data;
      state.status = 'submitted';
    },
  },
});

// Action creators are generated for each case reducer function
export const { chekingPatientFeedback, setPatientFeedback } =
  patientFeedbackSlice.actions;
